const ServiceRequest = {

    // FIELDS
    "farm": "Farm",
    "req_type": "Request Type",
    "comment": "Comment",
    "req_date": "Requirement Date",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "service": "Service Request",

    // ERROR
    "error_farm": "Select Farm",
    "error_req_type": "Select Request Type",
    "error_comment": "Enter Comment",
    "error_req_date": "Choose Requirement Date",

    // TABLE HEADER
    "table_farm": 'FARM',
    "table_req_type": 'REQUEST TYPE',
    "table_req_date": 'REQUIREMENT DATE',
    "table_status": "STATUS",

}

export default ServiceRequest;